<template>
  <div :class="$setClasses">
    <nxt-core-next-transition :visible="auto">
      <div>
        <nxt-core-input-address v-if="!displayCountry"
                                v-model:address="addressSync"
                                :country="modelCountry"
                                :input-id="inputId"
                                :label="label"
                                :placeholder="placeholder || ''"/>
        <nxt-core-input-country v-else
                                v-model="modelCountry"
                                :country="countrySync"
                                :flag-base-url="flagBaseUrl"
                                :input-id="`${inputId}-country`">
          <slot>
            <nxt-core-input-address v-model:address="addressSync"
                                    :country="modelCountry"
                                    :input-id="inputId"
                                    :label="label"
                                    :placeholder="placeholder || ''"
                                    :popover="popover"/>
          </slot>
        </nxt-core-input-country>
      </div>
    </nxt-core-next-transition>
    <nxt-core-next-transition :visible="displayDecomposedForm">
      <div :class="$vClass('decomposed')">
        <nxt-core-input-label v-if="subtitle || displayStreet"
                              :input-id="displayStreet ? `${inputId}-street` : undefined"
                              :text="displayStreet ? (subtitle || label) : subtitle"/>
        <el-row :gutter="25">
          <vee-field v-if="displayStreet"
                     as="span"
                     ref="provider-street"
                     v-slot="{meta, errors}"
                     :label="inputStreet.label.toLowerCase()"
                     :modelValue="streetSync"
                     :name="`${inputId}-street`"
                     :rules="inputStreet.rules">
            <el-col :class="generateClasses(meta,
             [$vClass('decomposed__item'), $vClass('decomposed__item__street')])"
                    :lg="12"
                    :md="24"
                    :sm="12"
                    :xs="24">
              <nxt-core-input-with-label v-model="streetSync"
                                         :input-id="`${inputId}-street`"
                                         :label="inputStreet.label"
                                         :placeholder="inputStreet.placeholder"
                                         autocomplete="street-address"
                                         class="input__value"
                                         @focus="handlerGenerateError(inputStreet)"/>
              <span v-if="displayErrors && Object.keys(errors).length"
                    :class="$vClass('decomposed__errors')">
                {{ errors[0] }}
              </span>
            </el-col>
          </vee-field>
          <vee-field as="span"
                     ref="provider-postal"
                     v-slot="{meta, errors}"
                     :label="inputPostal.label.toLowerCase()"
                     :modelValue="postalSync"
                     :name="`${inputId}-postal`"
                     :rules="inputPostal.rules">
            <el-col :class="generateClasses(meta,
             [$vClass('decomposed__item'), $vClass('decomposed__item__cp')])"
                    :lg="5"
                    :md="10"
                    :sm="5"
                    :xs="24">
              <nxt-core-input-with-label v-model="postalSync"
                                         :input-id="`${inputId}-postal`"
                                         :label="inputPostal.label"
                                         :placeholder="inputPostal.placeholder"
                                         autocomplete="postal-code"
                                         class="input__value"
                                         data-cy="address-postal"
                                         @focus="handlerGenerateError(inputPostal)"/>
              <span v-if="displayErrors && Object.keys(errors).length"
                    :class="$vClass('decomposed__errors')">
                {{ errors[0] }}
              </span>
            </el-col>
          </vee-field>
          <vee-field as="span"
                     ref="provider-city"
                     v-slot="{meta, errors}"
                     :label="inputCity.label.toLowerCase()"
                     :modelValue="citySync"
                     :name="`${inputId}-city`"
                     :rules="inputCity.rules">
            <el-col :class="generateClasses(meta,
             [$vClass('decomposed__item'), $vClass('decomposed__item__city')])"
                    :lg="7"
                    :md="14"
                    :sm="7"
                    :xs="24">
              <nxt-core-input-with-label v-model="citySync"
                                         :input-id="`${inputId}-city`"
                                         :label="inputCity.label"
                                         :placeholder="inputCity.placeholder"
                                         autocomplete="address-level2"
                                         class="input__value"
                                         data-cy="address-city"
                                         @focus="handlerGenerateError(inputCity)"/>
              <span v-if="displayErrors && Object.keys(errors).length"
                    :class="$vClass('decomposed__errors')">
                {{ errors[0] }}
              </span>
            </el-col>
          </vee-field>
        </el-row>
      </div>
    </nxt-core-next-transition>
  </div>
</template>

<script>
import AutoCompleteAddress
  from '@nextories/vue-core-components/src/components/molecules/address/NxtCoreAutoCompleteAddress.vue';
import getFlagBaseUrl from '../../../utils/flagBaseUrl';

export default {
  extends: AutoCompleteAddress,
  name: 'AutoCompleteAddress',
  props: {
    flagBaseUrl: {
      type: String,
      default: getFlagBaseUrl,
    },
  },
  mounted() {
    this.$nextTick(() => {
      // Display errors
      if (this.displayDecomposedForm && this.displayErrors && this.$refs) {
        for (const input of this.listInput) {
          if (input) {
            // Call vee-valide
            if (this.$refs[`provider-${input.provider}`]) {
              this.$refs[`provider-${input.provider}`].validate(this[input.type]);
            }
            // Generate errors of input
            this.handlerGenerateError(input);
          }
        }
      }
    });
  },
  methods: {
    generateClasses(meta, classes = []) {
      return classes.concat([meta.validated && meta.valid && 'is-valid',
        meta.validated && this.displayErrors && !meta.valid && 'is-invalid is-error']);
    },
  },
  watch: {
    displayErrors(value) {
      if (value) {
        for (const input of this.listInput) {
          this.handlerGenerateError(input);
        }
      }
    },
  },
};
</script>

<style lang="scss">
@use '@nextories/vue-core-components/src/assets/scss/components/molecules/address/NxtCoreAutoCompleteAddress';

.#{$prefixName}auto-complete-address {
  &__decomposed {
    .el-row > span {
      display: contents;
    }

    span > .#{$prefixName}auto-complete-address__decomposed__item.el-col {
      flex: none;
      max-width: none;
    }
  }
}
</style>
